import React, { useRef, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Parallax } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const MilIllustrationSlider = ({ images }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      // Attach your custom buttons
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className="mil-illustration-slider-frame mil-up">
      <Swiper
        modules={[Navigation, Parallax]}
        loop={true}
        parallax={false}
        onSwiper={setSwiperInstance}
        className="mil-illustration-slider"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div
              className="mil-illustration mil-fw-item"
              data-swiper-parallax-x="50"
              data-swiper-parallax-scale="1.3"
            >
              <div className="mil-image-frame">
                <img src={img} alt={`Slide ${index + 1}`} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="container">
        <div className="mil-illustration-slider-nav mil-up">
          <div className="mil-nav-buttons">
            {/* Attach refs to your buttons */}
            <div ref={prevRef} className="mil-slider-button mil-illustration-prev">
              Prev
            </div>
            <div ref={nextRef} className="mil-slider-button mil-illustration-next">
              Next
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilIllustrationSlider;
